import type { IdentityProvider } from 'app/network/identity';
import type { AppleAuthenticationCredential } from 'expo-apple-authentication';
import { useState } from 'react';

export interface AppleSignUpParams extends Pick<
  AppleAuthenticationCredential,
  'email' | 'fullName' | 'user' | 'authorizationCode'
> {
  token: string;
  provider: 'Apple';
  inviteCode?: string;
  userType?: string;
  onError?: () => void;
}

export interface AppleWebSignUpParams extends Omit<AppleSignUpParams, 'fullName'> {
  fullName: {
    givenName: string;
    familyName: string;
  };
}

export interface SocialIdPArgs {
  email: string;
  token: string;
  provider: Exclude<IdentityProvider, 'Apple'>;
  inviteCode?: string;
  userType?: string;
  onError?: () => void;
}

export type SocialIdPHandler = (args: SocialIdPArgs | (AppleSignUpParams | AppleWebSignUpParams)) => void;

export const useLoginButtonsState = () => {
  const [loginButtons, setLoginButtons] = useState({
    Google: false,
    Facebook: false,
    Apple: false,
    Email: false,
  });

  function setLoginButton(button: IdentityProvider | 'Email', value: boolean) {
    setLoginButtons((prev) => ({
      ...prev,
      [button]: value,
    }));
  }

  const setAllLoginButtons = (value: boolean) => {
    setLoginButtons({
      Google: value,
      Facebook: value,
      Apple: value,
      Email: value,
    });
  };

  return {
    loginButtons,
    setLoginButton,
    setAllLoginButtons,
    isAnyLoginButtonTrue: Object.values(loginButtons).includes(true),
  };
};

export interface SocialButtonProps {
  loginButtonsState: ReturnType<typeof useLoginButtonsState>;
  handleSocialIdP: SocialIdPHandler;
  iconOnly?: boolean;
}
